import { CookiesProvider } from "react-cookie";
import ReactDOM from "react-dom/client";
import {
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import 'semantic-ui-css/semantic.min.css';
import Layout from "./components/Layout/Layout";
import "./index.css";
import Home from "./pages/home/home";
import InputCustomerInfo from "./pages/InputCustomerInfo/InputCustomerInfo";
import InputMachine from "./pages/InputMachine/InputMachine";
import ReceiptCheck from "./pages/ReceiptCheck/ReceiptCheck";
import ReceiptCheckDetail from "./pages/ReceiptCheck/ReceiptCheckDetail";
import Solutions from "./pages/Solutions/Solutions";
import SolutionsPost from "./pages/Solutions/SolutionsPost";
import Symptoms3 from "./pages/Symptoms/Symptoms3";
import WarrantyInfo from "./pages/warrantyInfo/warrantyInfo";
import reportWebVitals from "./reportWebVitals";
import './static/bootstrap-grid.css';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const router = createBrowserRouter([
  {
    path: "/",
    children: [
      {
        path: "",
        element: <Home/>,
      },
    ],
  },
  {
    path: "/customer",
    element: <Layout />,
    children: [
      {
        path: "",
        element: <InputCustomerInfo/>,
      },
    ],
  },
  {
    path: "/warranty",
    children: [
      {path: "", element: <WarrantyInfo />,},
    ],
  },
  {
    path: "/models",
    element: <Layout />,
    children: [
      {
        path: "",
        element: <InputMachine />,
      },
    ],
  },
  {
    path: "/reservation",
    element: <Layout />,
    children: [
      {
        path: "",
        element: <Symptoms3 />,
      },
    ],
  },
  {
    path: "/solutions",
    children: [
      {path: "", element: <Solutions />,},
      {path: ":solutionsId", element: <SolutionsPost />,}, // /solutions/:solutionsId 로 접근시 solutionsId를 쿼리파라미터로 받아 라우팅 시켜줌
    ],
  },
  {
    path: "/receipt",
    children: [
      {path: "", element: <ReceiptCheck />,},
      {path: ":receiptId", element: <ReceiptCheckDetail />,},
    ],
  },
]
);

root.render(
  <CookiesProvider>
      <RouterProvider router={router} />
  </CookiesProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
